/**
 * Renderer gate for TactiCore Unit Structure authoring UX (Vite build-time).
 */

export function isTacticoreUnitStructureUxUiEnabled(): boolean {
  return import.meta.env.VITE_TACTICORE_UNIT_STRUCTURE_UX_ENABLED === 'true';
}
